export default __webpack_public_path__ + "drum.png?0e4d1a517218b570b82ba73a4c9e6fff";